/* eslint-disable react-hooks/exhaustive-deps, no-use-before-define */
import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import usePush from '../../hooks/usePush';
import { errors } from '../../util/errors';
import AuthenticationService from '../../services/authentication-service';
import LoadingMessage from '../../components/LoadingMessage/index';
import { useDispatch } from 'react-redux';
import { setUserData, setUserLocalStorage } from '../login/duck/actions/login';
import { login } from '../login/duck/actions/login';
import { useCacheActions } from '../../hooks/useFetch';
import OrganisationService from '../../services/organisation-service';
import { pendo } from '../../util/logging';

// eslint-disable-next-line react/prop-types
const Sage200Callback = ({ location: { search } }) => {
  const { execute } = usePush(AuthenticationService.loginSage200Callback, {
    errorToast: err => ({
      message: (err.code && errors[err.code]) || 'Sorry, unable to connect to Sage 200',
      autoClose: false,
    }),
  });

  const history = useHistory();
  const dispatch = useDispatch();
  const { invalidateEndpoint } = useCacheActions();
  const apiCall = async () => {
    const [err, result] = await execute(search);

    const data = result?.data?.loginSage200Callback;

    if (err || !data) {
      history.push('/');
      return;
    }

    const newOrganisations = data.newOrganisations || [];
    const existingOrganisations = data.existingOrganisations || [];
    const organisationsToConnect = data.organisationsToConnect || [];
    const state = data.state;
    const user = data.user;
    const userToken = data.token;

    user.token = userToken;
    dispatch(setUserData(user));

    pendo.track('integration_callback_completed', {
      integration: 'sage200',
      isNewOrganisation: newOrganisations.length > 0,
      requiresOrgSelection: organisationsToConnect.length > 0,
    });

    if (organisationsToConnect.length > 0) {
      history.push(`/select-organisations/sage200`, { organisationsToConnect, state });
    } else if (newOrganisations.length > 0) {
      history.push(`/?organisation=${newOrganisations[0].ShortCode}`);
    } else if (existingOrganisations.length > 0) {
      history.push(`/o/${existingOrganisations[0].ShortCode}`);
    } else {
      history.push('/');
    }

    await invalidateEndpoint(OrganisationService.get);
    setUserLocalStorage(user);
    dispatch(login());
  };

  useEffect(() => {
    apiCall();
  }, []);

  return <LoadingMessage center useLogoAnimation />;
};
export default Sage200Callback;
